import { render } from "./TrainingDatabaseReport.vue?vue&type=template&id=530e0f56&scoped=true"
import script from "./TrainingDatabaseReport.vue?vue&type=script&lang=js"
export * from "./TrainingDatabaseReport.vue?vue&type=script&lang=js"

import "./TrainingDatabaseReport.vue?vue&type=style&index=0&id=530e0f56&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530e0f56"]])

export default __exports__